import {
  handleAddRow,
  handleDeleteRow,
  handleTableData,
  updateTotals,
} from '@/utils/formula/DiamondStoneTable';
import { DeleteFilled, PlusOutlined } from '@ant-design/icons';
import { Form, Input, message, Select, Table } from 'antd';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ShowAllData } from '../../../apiError/apiShow';
import { useTransactionContext } from '../../../context/TransactionContext';
import {
  OnlyIntegerUptoThreeDigit,
  OnlyIntegerUptoThreeDigitWithoutDecimal,
  weightValidationDiamondCarat,
} from '../../validation/FormValidation';
import CustomSelect from '@/utils/search/Search';
import ItemForm from '@/components/forms/master/inventory/item/ItemForm';
import GlobalFormModal from '@/utils/modal/GlobalFormModal';
import { CenterElement } from '@/utils/tableHeader';
import GlobalDivider from '@/utils/divider/GlobalDivider';
import { ModalFooterButton } from '@/components/forms/transaction/purchase/footerButtons';
import DraggableModal from '@/common/ant-components/DraggableModal';
import CalculatorAppWithModalDiamondStone from '@/layouts/componets/calculator-app-with-modal -for-diamond-stone';
import ZeroBlankInput from '@/components/reusable/ZeroBlanketInput';

/**
 * Component representing a table for utility code window.
 * @param {object} props - Component props.
 * @param {object} props.formData - Form data object.
 * @param {function} props.setFormData - Function to set form data.
 * @param {object} props.codeModalData - Data related to code modal.
 * @returns {JSX.Element} - UtilCodeWindowTable component.
 */

const UtilCodeWindowTable = ({
  formData,
  setFormData,
  primaryWeight,
  primaryCalculationType,
  openDsT = false,
  setopenDsT = () => {},
  isDirectDiamondStone = false,
}) => {
  const {
    tableData,
    setTableData,
    totalPcsDiamond,
    totalPcsStone,
    totalDiamondWeight,
    totalStoneWeight,
    totalPrate,
    totalDiamondAmount,
    totalStoneAmount,
    setTotalDiamondAmount,
    setTotalDiamondWeight,
    setTotalPcsDiamond,
    setTotalPcsStone,
    setTotalStoneWeight,
    setTotalPrate,
    setTotalStoneAmount,
    setTotalGramLalValue,
    isNewEntry,
    // setIsNewEntry,
  } = useTransactionContext();

  const [record, setRecord] = useState({});

  const { setCalculatorOpen, setTargetId, targetId } = useTransactionContext();

  const location = useLocation();
  const routeInclude = ['sales/create', 'sales/edit', 'sales/order'];
  const showSalesRateColumn = routeInclude?.some((route) =>
    location.pathname.includes(route),
  );

  const showSalesIncomingRate = [
    'sales/create',
    'sales/edit',
    // 'sales/return/',
    'sales/return/',
    'purchase/return/',
  ].some((route) => location.pathname.includes(route));

  const isReturn = ['sales/return/', 'purchase/return/'].some((route) =>
    location.pathname.includes(route),
  );
  const isSalesReturn = location.pathname.includes('sales/return/');

  const isSalesCreateEdit =
    location.pathname.includes('sales/create') ||
    location.pathname.includes('sales/edit');

  const showSalesActionColumn = [
    // 'sales/create',
    // 'sales/edit',
    '/issue/karigar/create/',
    '/issue-karigar/edit/',
    '/issue/party/create/',
    '/issue-party/edit/',
  ].some((route) => location.pathname.includes(route));
  const [form] = Form.useForm();
  const [tableItem, setTableItem] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);

  const isSalesEdit = location?.pathname.includes('transaction/sales/edit');

  const handleAddClick = () => {
    setIsModalVisible(true);
  };

  const closeModal = () => {
    setIsModalVisible(false);
  };

  /**
   * Fetches table item data from API and sets it to state.
   */
  const showTabaleItemData = async () => {
    const response = await ShowAllData.showDetails(
      `/account/item/wise/item/type/list/?isStone=${true}`,
    );
    setTableItem(response.data);
  };

  useEffect(() => {
    showTabaleItemData();
  }, []);

  /**
   * Handles table data update for a specific row.
   * @param {string} key - Key of the row.
   * @param {string} field - Field to update.
   * @param {any} value - New value for the field.
   * @param {string} ornamentid - Ornament ID.
   * @param {string} itemtypeid - Item type ID.
   * @param {string} itemtypesname - Item type name.
   */
  const onHandleTableData = (
    key,
    field,
    value,
    ornamentid,
    itemtypeid,
    itemtypesname,
  ) => {
    handleTableData(
      primaryCalculationType,
      key,
      field,
      value,
      ornamentid,
      itemtypeid,
      itemtypesname,
      tableData,
      setTableData,
      isSalesEdit,
    );
  };

  const handleKeyDownC = (e, record, field) => {
    if (e) {
      setTargetId(e?.target?.id || field);
      setRecord({
        record: record,
        key: record.key,
        field: field,
      });
    }
    if (e?.altKey && e.code === 'KeyC') {
      e.preventDefault();
      setCalculatorOpen && setCalculatorOpen(true);
    }
  };

  const NumberInput = isDirectDiamondStone ? ZeroBlankInput : Input;

  const columns = [
    {
      title: <CenterElement>S.N.</CenterElement>,
      dataIndex: 'key',
      render: (_, record) => record.key || '',
      width: '10px',
      fixed: 'left',
    },
    {
      title: <CenterElement>Item</CenterElement>,
      dataIndex: 'typeId',
      width: '200px',
      fixed: 'left',
      render: (_, record) => {
        const previousData = record?.itemTypeName?.toLowerCase();
        return (
          <CustomSelect
            value={record?.itemTypesName || record?.itemId || undefined}
            style={{ width: '100%' }}
            placeholder="Select"
            disabled={showSalesActionColumn || isReturn || isDirectDiamondStone}
            onChange={(value, option) => {
              const itemTypeNameSelected = option?.itemtypesname?.toLowerCase();

              if (isSalesCreateEdit) {
                if (previousData === itemTypeNameSelected) {
                  onHandleTableData(
                    record.key,
                    'isName',
                    value,
                    option?.ornamentid,
                    option?.itemtypeid,
                    option?.itemtypesname,
                  );
                } else if (previousData) {
                  message.info(
                    <span>
                      Please select{' '}
                      <span style={{ color: '#fadb14', fontWeight: 'bold' }}>
                        {previousData}
                      </span>
                      . Cannot change previous{' '}
                      <span style={{ color: '#fadb14', fontWeight: 'bold' }}>
                        {previousData}
                      </span>{' '}
                      to {itemTypeNameSelected}.
                    </span>,
                  );
                } else {
                  onHandleTableData(
                    record.key,
                    'isName',
                    value,
                    option?.ornamentid,
                    option?.itemtypeid,
                    option?.itemtypesname,
                  );
                }
              } else {
                onHandleTableData(
                  record.key,
                  'isName',
                  value,
                  option?.ornamentid,
                  option?.itemtypeid,
                  option?.itemtypesname,
                );
              }
            }}
            options={tableItem?.map((item) => ({
              key: item?.typeId,
              value: item.typeId,
              ornamentid: item?.typeId,
              itemtypeid: item?.itemTypeId,
              itemtypesname: item?.itemTypeName,
              label: item?.name,
            }))}
            onAddClick={handleAddClick}
          />
        );
      },
    },

    {
      title: <CenterElement>Rate on</CenterElement>,
      dataIndex: 'rateOn',
      width: '100px',
      fixed: 'left',
      render: (_, record) => (
        <Select
          value={record.rateOn || undefined}
          style={{ width: '100%' }}
          placeholder="Select"
          disabled={isReturn}
          onChange={(value) => onHandleTableData(record.key, 'rateOn', value)}
        >
          <Select.Option value="pcs">Pcs</Select.Option>
          <Select.Option value="wt">Wt</Select.Option>
          <Select.Option value="bulk">fix</Select.Option>
        </Select>
      ),
    },
    {
      title: <CenterElement>Pcs</CenterElement>,
      dataIndex: 'pcs',
      width: 80,
      fixed: 'left',
      render: (_, record) => (
        <NumberInput
          onKeyDown={(e) => {
            OnlyIntegerUptoThreeDigitWithoutDecimal(e);
            handleKeyDownC(e, record, 'pcs');
          }}
          style={{ maxWidth: '100%', minWidth: '60px' }}
          maxLength={3}
          placeholder="0"
          disabled={
            (showSalesActionColumn || isReturn) && !isDirectDiamondStone
          }
          value={record.pcs}
          onChange={(e) =>
            onHandleTableData(record.key, 'pcs', Number(e.target.value) || '')
          }
        />
      ),
    },
    {
      title: <CenterElement>Unit</CenterElement>,
      dataIndex: 'unit',
      width: 80,
      render: (_, record) => (
        <Select
          style={{ width: '100%' }}
          placeholder="Select"
          disabled={
            (showSalesActionColumn || isReturn) && !isDirectDiamondStone
          }
          value={record.unit}
          onChange={(value) => onHandleTableData(record.key, 'unit', value)}
        >
          {primaryCalculationType === 'lal' ? (
            <Select.Option
              value="lal"
              disabled={
                record.disableUnit ||
                record?.itemTypeName?.toLowerCase() === 'diamond'
              }
            >
              lal
            </Select.Option>
          ) : (
            <Select.Option
              value="gm"
              disabled={
                record.disableUnit ||
                record?.itemTypeName?.toLowerCase() === 'diamond'
              }
            >
              Gm
            </Select.Option>
          )}

          <Select.Option value="crt">Crt</Select.Option>
        </Select>
      ),
    },
    {
      title: <CenterElement>Weight</CenterElement>,
      dataIndex: 'weight',
      width: 70,
      render: (_, record) => (
        <NumberInput
          style={{ width: '100%' }}
          onKeyDown={(e) => {
            OnlyIntegerUptoThreeDigit(e, 'weight', formData);
            handleKeyDownC(e, record, 'weight');
          }}
          placeholder="0"
          disabled={
            (showSalesActionColumn || isReturn) && !isDirectDiamondStone
          }
          value={record.weight}
          // precision={2}
          onChange={(e) => {
            const { isValid, inputValue } = weightValidationDiamondCarat(
              e.target.value,
              record?.unit,
            );
            if (isValid) {
              onHandleTableData(record.key, 'weight', inputValue || '');
            }
          }}
        />
      ),
    },
    ...(showSalesRateColumn || isSalesReturn
      ? []
      : [
          {
            title: <CenterElement>P. Rate</CenterElement>,
            dataIndex: 'purchaseRate',
            width: 100,
            render: (_, record) => (
              <NumberInput
                style={{ width: '100%' }}
                placeholder="0"
                disabled={
                  (showSalesActionColumn || isReturn) && !isDirectDiamondStone
                }
                onKeyDown={(e) => {
                  OnlyIntegerUptoThreeDigit(e);
                  handleKeyDownC(e, record, 'purchaseRate');
                }}
                value={record.purchaseRate}
                onChange={(e) => {
                  const raw = e.target.value;
                  const sanitizedValue = raw.replace(/^(-?)0+(\d)/, '$1$2');
                  onHandleTableData(
                    record.key,
                    'purchaseRate',
                    sanitizedValue || '',
                  );
                }}
              />
            ),
          },
        ]),

    {
      title: <CenterElement>S. Rate</CenterElement>,
      dataIndex: 'salesRate',
      width: 100,
      render: (_, record) => (
        <NumberInput
          placeholder="0"
          style={{ width: '100%' }}
          onKeyDown={(e) => {
            OnlyIntegerUptoThreeDigit(e);
            handleKeyDownC(e, record, 'salesRate');
          }}
          disabled={isReturn && !isSalesReturn && !isDirectDiamondStone}
          value={record.salesRate}
          onChange={(e) => {
            const raw = e.target.value;
            const sanitizedValue = raw.replace(/^(-?)0+(\d)/, '$1$2');
            onHandleTableData(record.key, 'salesRate', sanitizedValue || '');
          }}
        />
      ),
    },

    {
      title: 'Hc',
      dataIndex: 'hc',
      width: 100,
      render: (_, record) => (
        <Input
          placeholder="hc"
          style={{ width: '100%' }}
          value={record.hc}
          disabled={
            (showSalesActionColumn || isReturn) && !isDirectDiamondStone
          }
          onChange={(e) => onHandleTableData(record.key, 'hc', e.target.value)}
        />
      ),
    },
    {
      title: 'Color',
      dataIndex: 'color',
      width: 80,
      render: (text, record) => (
        <Input
          placeholder="color"
          style={{ width: '80px' }}
          value={record.color}
          disabled={
            (showSalesActionColumn || isReturn) && !isDirectDiamondStone
          }
          onChange={(e) =>
            onHandleTableData(record.key, 'color', e.target.value)
          }
        />
      ),
    },
    {
      title: 'Clarity',
      dataIndex: 'clarity',
      render: (text, record) => (
        <Input
          placeholder="clarity"
          style={{ width: '80px' }}
          value={record.clarity}
          disabled={
            (showSalesActionColumn || isReturn) && !isDirectDiamondStone
          }
          onChange={(e) =>
            onHandleTableData(record.key, 'clarity', e.target.value)
          }
        />
      ),
    },
    {
      title: 'Cut',
      dataIndex: 'cut',
      render: (text, record) => (
        <Input
          placeholder="cut"
          style={{ width: '80px' }}
          disabled={
            (showSalesActionColumn || isReturn) && !isDirectDiamondStone
          }
          value={record.cut}
          onChange={(e) => onHandleTableData(record.key, 'cut', e.target.value)}
        />
      ),
    },
    {
      title: 'Amount',
      dataIndex: 'amount',
      width: 150,
      render: (_, record) => (
        <NumberInput
          placeholder={isDirectDiamondStone ? '0' : 'Amount'}
          style={{ minWidth: '120px', maxWidth: '100%' }}
          value={record.amount}
          disabled
        />
      ),
    },
    {
      title: 'Remark',
      dataIndex: 'remark',
      width: 200,
      render: (text, record) => (
        <Input
          placeholder="remark"
          style={{ minWidth: '150px', maxWidth: '100%' }}
          value={record.remark}
          disabled={isReturn}
          onChange={(e) =>
            onHandleTableData(record.key, 'remark', e.target.value)
          }
        />
      ),
    },
    ...(showSalesActionColumn || isReturn || isDirectDiamondStone
      ? []
      : [
          {
            title: 'Action',
            fixed: 'right',
            render: (text, record) => (
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-around',
                  width: '45px',
                }}
              >
                <Link
                  onClick={() => handleAddRow(tableData, setTableData)}
                  className="edit"
                  style={{ color: 'blue', background: 'none' }}
                >
                  <PlusOutlined />
                </Link>
                <Link
                  style={{ color: 'red', background: 'none' }}
                  onClick={() =>
                    handleDeleteRow(tableData, setTableData, record.key)
                  }
                  className="delete"
                >
                  <DeleteFilled />
                </Link>
              </div>
            ),
          },
        ]),
  ];

  /**
   * Handles updating total values based on table data changes.
   */
  const handleUpdateTotals = () => {
    updateTotals(
      form,
      setTotalPrate,
      setTotalPcsDiamond,
      setTotalPcsStone,
      setTotalStoneWeight,
      setTotalDiamondWeight,
      setTotalStoneAmount,
      setTotalDiamondAmount,
      setTotalGramLalValue,
      tableData,
      formData,
      setFormData,
      primaryCalculationType,
      primaryWeight,
    );
  };

  useEffect(() => {
    handleUpdateTotals();
  }, [tableData]);

  const commonChildren = () => {
    return (
      <>
        {((showSalesIncomingRate && !isNewEntry) || isDirectDiamondStone) && (
          <GlobalDivider name="Diamond/Stone Table" />
        )}
        <Table
          bordered
          dataSource={tableData || []}
          columns={columns}
          pagination={false}
          scroll={{ x: true }}
          rowKey="key"
        />
        <GlobalFormModal isVisible={isModalVisible} onClose={closeModal}>
          <ItemForm onClose={closeModal} refreshTable={showTabaleItemData} />
        </GlobalFormModal>
        {(!showSalesIncomingRate || isNewEntry) && !isDirectDiamondStone && (
          <ModalFooterButton
            isFromModal
            onClose={() => {
              setopenDsT(false);
            }}
          />
        )}

        <CalculatorAppWithModalDiamondStone
          form={form}
          formData={formData}
          targetId={targetId}
          setFormData={setFormData}
          record={record}
          onHandleTableData={onHandleTableData}
        />
      </>
    );
  };

  return (
    <>
      {(showSalesIncomingRate && formData?.diamondStones?.length > 0) ||
      isDirectDiamondStone ? (
        commonChildren()
      ) : (
        <DraggableModal
          open={openDsT}
          onCancel={() => setopenDsT(false)}
          width={'100%'}
          footer={null}
          maskClosable={false}
          title={<div className="tw-py-2">Diamond/Stone Table</div>}
        >
          {commonChildren()}
        </DraggableModal>
      )}
    </>
  );
};

UtilCodeWindowTable.propTypes = {
  formData: PropTypes.object.isRequired,
  setFormData: PropTypes.func.isRequired,
};

export default UtilCodeWindowTable;
